import {
  ORDER_METHODS,
  SMART_PRICING_MODIFIER_TYPE,
  SMART_PRICING_RESOURCE_TYPE,
} from '../../../../../services/exports/Constants';

export default {
  title: {
    [SMART_PRICING_RESOURCE_TYPE.company]: '{{name}} yleinen älykäs hinnoittelusääntö',
    [SMART_PRICING_RESOURCE_TYPE.franchise]: '{{name}} pääkonseptin älykäs hinnoittelusääntö',
    [SMART_PRICING_RESOURCE_TYPE.menu]: '{{name}} valikon älykäs hinnoittelusääntö',
    [SMART_PRICING_RESOURCE_TYPE.category]: '{{name}} kategorian älykäs hinnoittelusääntö',
    [SMART_PRICING_RESOURCE_TYPE.product]: '{{name}} tuotteen älykäs hinnoittelusääntö',
    [SMART_PRICING_RESOURCE_TYPE.modifier_group]: '{{name}} lisäosaryhmän älykäs hinnoittelusääntö',
    [SMART_PRICING_RESOURCE_TYPE.modifier]: '{{name}} lisäosan älykäs hinnoittelusääntö',
  },
  labels: {
    new: 'Uusi',
    base_price: '{{name}} perushinta: {{value}}',
  },
  form: {
    resource: {
      [SMART_PRICING_RESOURCE_TYPE.menu]: 'Valikko',
      [SMART_PRICING_RESOURCE_TYPE.category]: 'Kategoria',
      [SMART_PRICING_RESOURCE_TYPE.product]: 'Tuote',
      [SMART_PRICING_RESOURCE_TYPE.modifier_group]: 'Lisäosaryhmä',
      [SMART_PRICING_RESOURCE_TYPE.modifier]: 'Lisäosa',
      placeholder: 'Valitse {{resource}}',
    },
    order_methods: {
      label: 'Tilaustavat',
      placeholder: 'Valitse tilaustavat, joihin sääntöä sovelletaan',
      options: {
        [ORDER_METHODS.pickup]: 'Nouto',
        [ORDER_METHODS.delivery]: 'Toimitus',
        [ORDER_METHODS.on_site]: 'Pöytätilaus',
      },
    },
    modifier_type: {
      label: 'Hinnanmuutoksen tyyppi',
      placeholder: 'Valitse hinnanmuutoksen tyyppi',
      disabled_tooltip:
        'Absoluuttinen ei ole käytettävissä koko valikon säännöille, koska se korvaisi jokaisen tuotteen hinnan.',
      tooltip: {
        title: 'Muutostyyppi määrittää, miten hintoja muutetaan',
        description: {
          [SMART_PRICING_MODIFIER_TYPE.absolute]: 'Absoluuttinen: korvaa kohteen hinnan annetulla muutosarvolla',
          [SMART_PRICING_MODIFIER_TYPE.percentage]:
            'Prosentti: lisää/vähentää annetun prosenttiosuuden kohteen perushinnasta riippuen muutosarvon etumerkistä',
          [SMART_PRICING_MODIFIER_TYPE.fixed_value]:
            'Kiinteä arvo: lisää/vähentää annetun kiinteän arvon perushinnasta riippuen muutosarvon etumerkistä',
        },
      },
      options: {
        [SMART_PRICING_MODIFIER_TYPE.absolute]: 'Absoluuttinen',
        [SMART_PRICING_MODIFIER_TYPE.percentage]: 'Prosentti',
        [SMART_PRICING_MODIFIER_TYPE.fixed_value]: 'Kiinteä arvo',
      },
    },
    modifier_value: {
      label: 'Hinnanmuutoksen arvo',
    },
    round: {
      label: 'Pyöristä lopullinen hinta',
      tooltip:
        'Pyöristää lopullisen hinnan ylöspäin 10:een (esim. 14,91, 14,93, 14,99 muuttuvat arvoksi 15,00). Hyödyllisintä prosenttisäännöissä',
    },
    is_visible: {
      label: 'Näytä asiakkaalle tarjouksena',
    },
    name: {
      label: 'Nimi',
      placeholder: 'Kirjoita asiakasystävällinen nimi',
      default: '{{value}} alennus kohteesta {{resource}}',
    },
  },
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
    failed_to_save_changes: 'Muutosten tallentaminen epäonnistui',
    changes_got_saved: 'Muutokset tallennettu',
  },
};
